interface EventTitleProps {
  title: string;
  textColor: string;
}

/**
 * EventTitle component
 * @param title - title of the event
 * @param textColor - text color of the title
 * @returns EventTitle component
 */

export const EventTitle = ({ title, textColor }: EventTitleProps) => {
  return (
    <h1
      className='font-semibold min-[350px]:text-[20px] block overflow-hidden whitespace-normal leading-[26px] md:text-[24px] min-[1200px]:text-[28px] lg:leading-[36px] min-[350px]:mt-0 sm:mt-1 min-[350px]:mb-1 sm:mb-2 font-body'
      style={{ color: textColor, display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2 }}
    >
      {title}
    </h1>
  );
};
